export default class StreamGaugesService {
  static async getGauges(filters = {}) {
    const params = new URLSearchParams();
    if (filters.search) params.append('search', filters.search);
    if (filters.huc) params.append('huc', filters.huc);
    if (filters.has_forecast) params.append('has_forecast', filters.has_forecast);
    if (filters.has_river) params.append('has_river', filters.has_river);
    if (filters.date) params.append('date', filters.date);
    const query = params.toString();
    const url = `/stream_gauges${query ? '?' + query : ''}`;

    return new Promise((resolve, reject) => {
      return fetch(url, { method: "GET", headers: { Accept: "application/json" } })
        .then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async getGauge(id) {
    return new Promise((resolve, reject) => {
      return fetch(`/stream_gauges/${id}`, { method: "GET", headers: { Accept: "application/json" } })
        .then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async updateGauge(id, data) {
    return new Promise((resolve, reject) => {
      return fetch(`/stream_gauges/${id}`, {
        method: "PUT",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
        body: JSON.stringify(data),
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async getConditions(id, period, date) {
    var params = [];
    if (date) { params.push('date=' + date); }
    else if (period) { params.push('period=' + period); }
    var url = '/stream_gauges/' + id + '/conditions' + (params.length ? '?' + params.join('&') : '');
    return new Promise(function(resolve, reject) {
      return fetch(url, { method: "GET", headers: { Accept: "application/json" } })
        .then(function(r) { return r.json(); }).then(function(d) { resolve(d); }).catch(function(e) { reject(e); });
    });
  }

  static async syncAll() {
    return new Promise((resolve, reject) => {
      return fetch('/stream_gauges/sync_all', {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async syncSites() {
    return new Promise((resolve, reject) => {
      return fetch('/stream_gauges/sync_sites', {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async fetchReadings() {
    return new Promise((resolve, reject) => {
      return fetch('/stream_gauges/fetch_readings', {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async fetchForecasts() {
    return new Promise((resolve, reject) => {
      return fetch('/stream_gauges/fetch_forecasts', {
        method: "POST",
        headers: { Accept: "application/json", "Content-Type": "application/json" },
      }).then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }

  static async getSyncLog() {
    return new Promise((resolve, reject) => {
      return fetch('/stream_gauges/sync_log', { method: "GET", headers: { Accept: "application/json" } })
        .then(r => r.json()).then(d => resolve(d)).catch(e => reject(e));
    });
  }
}
